@if (customFieldDefinitions()) {
    <form
        [ngClass]="{ 'customer-details-form--editing': editing() }"
        [formGroup]="contactForm"
        (ngSubmit)="submitForm()"
    >
        <div class="row">
            <div class="col-3 label">
                <label class="form-label" for="fullName">Full Name</label>
            </div>
            <div class="col-8">
                <input
                    formControlName="fullName"
                    type="text"
                    class="form-control"
                    [ngbTooltip]="contactForm.get('fullName')?.value"
                    placement="top"
                />
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-3 label">
                <label class="form-label" for="emailAddress">
                    Email Address
                    <span class="text-danger">*</span>
                </label>
            </div>
            <div class="col-8 position-relative">
                <input
                    formControlName="emailAddress"
                    validateContactField
                    [formFieldInEditMode]="editing()"
                    [formFieldErrorMessage]="{
                        email: 'Please provide a valid email address.',
                        required: 'Mandatory fields cannot be left blank.',
                    }"
                    type="email"
                    class="form-control"
                    [ngbTooltip]="contactForm.get('emailAddress')?.value"
                    placement="top"
                />
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-3 label">
                <label class="form-label" for="phoneNumber">
                    Phone Number
                    <span class="text-danger">*</span>
                </label>
            </div>

            <div class="col-8 position-relative">
                <input
                    formControlName="phoneNumber"
                    validateContactField
                    [formFieldInEditMode]="editing()"
                    [formFieldErrorMessage]="{
                        ukNumber: 'Phone number must start with +44 or 0.',
                        required: 'Mandatory fields cannot be left blank.',
                        phoneNumberExists:
                            'An end customer record exists with this phone number',
                        startsWithPlus44TooLong:
                            'Numbers starting +44 have a maximum length of 13 ',
                        startsWithZeroTooLong:
                            'Numbers starting 0 have a maximum length of 11 ',
                        invalid: 'This phone number is invalid',
                    }"
                    type="text"
                    class="form-control"
                    [ngbTooltip]="contactForm.get('phoneNumber')?.value"
                    placement="top"
                />
            </div>
        </div>

        <ng-container formArrayName="customFields">
            @for (
                customField of customFields.controls;
                track customField.get('fieldDefinitionId');
                let i = $index
            ) {
                <div class="row mt-3" [formGroupName]="i">
                    <div class="col-3 label">
                        <label class="form-label" for="customFields">
                            {{
                                getCustomFieldLabel(
                                    customField.get('fieldDefinitionId')?.value
                                )
                            }}
                        </label>
                    </div>
                    <div class="col-8">
                        <div>
                            @if (!editing()) {
                                <input
                                    formControlName="value"
                                    type="text"
                                    class="form-control"
                                    [ngbTooltip]="
                                        customField.get('value')?.value
                                    "
                                    placement="top"
                                />
                            } @else {
                                @switch (
                                    getCustomFieldType(
                                        customField.get('fieldDefinitionId')
                                            ?.value
                                    )
                                ) {
                                    @case ('Text') {
                                        <input
                                            formControlName="value"
                                            type="text"
                                            class="form-control"
                                            [ngbTooltip]="
                                                customField.get('value')?.value
                                            "
                                            placement="top"
                                        />
                                    }
                                    @case ('Choice') {
                                        <telxl-dropdown
                                            colour="dropdown"
                                            [outline]="true"
                                            [selected]="
                                                getSelectedOption(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value
                                                )
                                            "
                                            [menuItems]="
                                                getCustomFieldOptions(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value
                                                )
                                            "
                                            (selectedChange)="
                                                onOptionSelected(
                                                    customField.get(
                                                        'fieldDefinitionId'
                                                    )?.value,
                                                    $event
                                                )
                                            "
                                            [ngbTooltip]="
                                                customField.get('value')?.value
                                            "
                                            placement="top"
                                        />
                                    }
                                }
                            }
                        </div>
                    </div>
                </div>
            }
        </ng-container>
    </form>
}
